import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApiRequestUsageSlice } from './get';

export const coreDataSecurityApiRequestUsageReducers = combineReducers({
	get: getCoreDataSecurityApiRequestUsageSlice.asyncReducers
});

export const coreDataSecurityApiRequestUsageWatchers = combineAllWatchers([ getCoreDataSecurityApiRequestUsageSlice.asyncWatchers ]);
